import {driverAssignedTrackingIdsNetwork} from "../network/DriverPackageSummaryNetwork";
import {
    DRIVER_ASSIGNED_TRACKING_ID_LIST_SUCCESS,
    DRIVER_ASSIGNED_TRACKING_ID_LIST
} from "../constants/DriverPackageSummaryConstants";


export const DriverAssignedTrackingIdListReducer = (state, action) => {
    switch (action.type) {
        case DRIVER_ASSIGNED_TRACKING_ID_LIST:
            const  {driverId, dispatcher} = action.data;
            driverAssignedTrackingIdsNetwork(driverId, dispatcher);
            return {...state, isLoading: true, requestCompleted: false};
        case DRIVER_ASSIGNED_TRACKING_ID_LIST_SUCCESS:
            return {...state,
                driverAssignedTrackingId: action.data,
                isLoading: false,
                requestCompleted: true,
                message: action.data.message,
                type: action.data.alertType};
        default:
            return state
    }
};


// WEBPACK FOOTER //
// ./src/components/driverPackageSummary/reducer/DriverAssignedTrackingIdListReducer.js